"use strict";

module.exports = {
  easing: {
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
  },
  duration: {
    standard: 300,
    short: 250,
    enteringScreen: 225,
    shorter: 200,
    leavingScreen: 195,
    shortest: 150,
    complex: 375
  }
};
//# sourceMappingURL=transitions.js.map